import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthLayout from '../container/authentication/index';

const Login = lazy(() => import('../container/authentication/overview/signIn'));
const SignUp = lazy(() => import('../container/authentication/overview/signUp'));
const ForgotPass = lazy(() => import('../container/authentication/overview/forgotPass'));
const VerifCode = lazy(() => import('../container/authentication/overview/verificationCode'));

const NotFound = () => {
  return <Redirect to="/" />;
};

const FrontendRoutes = () => {
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path="/" component={Login} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path="/forgotpass" component={ForgotPass} />
        <Route exact path="/verifcode" component={VerifCode} />
        <Route exact path="*" component={NotFound} />
      </Suspense>
    </Switch>
  );
};

export default AuthLayout(FrontendRoutes);
